<template>
	<div>
		<el-container>
			<el-aside width="240px">
				<aside>
					<div class="left-logo">
						<img src="https://zhimaicoud.cn/upload/common/default/97012fc9129c7a121f88a5cf32eaac551765432237%5E%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250526105222_162.png"
							alt="" />
					</div>
					<div class="nav-menu">
						<div class="nav-item" :class="{ active: $route.path === '/index/dashboard' }"
							@click="goDashboard">
							<div class="nav-icon">
								<img src="https://hmcdn.1laigc.com/hm-avatar/Menu-PDSC.png" alt="" />
							</div>
							<span class="nav-text">仪表盘</span>
							<div class="nav-indicator"></div>
						</div>
						<div class="nav-item"
							:class="{ active: $route.path === '/index' && $route.path !== '/index/dashboard' && $route.path !== '/index/qiniu' }"
							@click="all">
							<div class="nav-icon">
								<img src="https://hmcdn.1laigc.com/hm-avatar/Menu-PDSC.png" alt="" />
							</div>
							<span class="nav-text">总览</span>
							<div class="nav-indicator"></div>
						</div>
						<div class="nav-item" :class="{ active: $route.path === '/index/agent' }" @click="goAgent">
							<div class="nav-icon">
								<img src="https://hmcdn.1laigc.com/hm-avatar/Menu-PDSC.png" alt="" />
							</div>
							<span class="nav-text">模型广场</span>
							<div class="nav-indicator"></div>
						</div>
						<div class="nav-item" @click="goOrder">
							<div class="nav-icon">
								<img src="https://hmcdn.1laigc.com/hm-avatar/Menu-WDZC2.png" alt="" />
							</div>
							<span class="nav-text">充值记录</span>
							<div class="nav-indicator"></div>
						</div>
						<div class="nav-item" @click="goExpend">
							<div class="nav-icon">
								<img src="https://hmcdn.1laigc.com/hm-avatar/Menu-XFRW.png" alt="" />
							</div>
							<span class="nav-text">消耗记录</span>
							<div class="nav-indicator"></div>
						</div>
						<div class="nav-item" @click="goregulate">
							<div class="nav-icon">
								<img src="https://hmcdn.1laigc.com/hm-avatar/Menu-WDSC2.png" alt="" />
							</div>
							<span class="nav-text">应用密钥管理</span>
							<div class="nav-indicator"></div>
						</div>
						<div class="nav-item" @click="openApiDoc">
							<div class="nav-icon">
								<img src="https://hmcdn.1laigc.com/hm-avatar/Menu-PDSC.png" alt="" />
							</div>
							<span class="nav-text">API文档</span>
							<div class="nav-indicator"></div>
						</div>
						<!-- <div class="nav-item" :class="{ active: $route.path === '/index/qiniu' }" @click="goQiniu">
							<div class="nav-icon">
								<img src="https://hmcdn.1laigc.com/hm-avatar/Menu-PDSC.png" alt="" />
							</div>
							<span class="nav-text">七牛云存储</span>
							<div class="nav-indicator"></div>
						</div> -->
					</div>
					<div class="contact-card">
						<div class="contact-icon">
							<img src="https://hmcdn.1laigc.com/hm-avatar/Menu-FWZG.png" alt="客服" />
						</div>
						<div class="contact-content">
							<div class="contact-title">联系客服</div>
							<div class="contact-desc">有问题随时咨询</div>
						</div>
						<button class="contact-btn" @click="showContactDialog = true">立即咨询</button>
					</div>

					<el-dialog title="联系客服" :visible.sync="showContactDialog" width="400px" center
						custom-class="contact-dialog">
						<div class="contact-qrcode">
							<img src="https://zhimayun0023.oss-cn-beijing.aliyuncs.com/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20260323192356_134_21.jpg"
								alt="客服二维码" />
						</div>
						<p class="contact-tip">扫描上方二维码添加客服微信</p>
					</el-dialog>
				</aside>
			</el-aside>
			<el-container>
				<el-header>
					<nav>
						<div class="left">
							<span @click="goDashboard">仪表盘</span>
						</div>
						<div class="right">
							<ul>
								<li @click="goindex">首页</li>
								<li @click="goapply">应用模块</li>
								<li @click="ChangeInfo">修改信息</li>
								<li @click="loginout">退出登录</li>
							</ul>
						</div>
					</nav>
				</el-header>
				<el-main>
					<div class="content">

						<main>
							<div v-if="$route.path === '/index'" class="default-content">
								<div class="head">
									<div>
										<img :src="userInfor.headavatar" alt="" v-if="userInfor.headavatar != ''" />
										<img src="../../assets/img01.jpg" alt="" v-else />
									</div>
									<div class="infor">
										<h6>{{ userInfor.account }}</h6>
										<p>账号ID:{{ userInfor.id }}</p>
										<div>
											<el-popover placement="right" width="400" trigger="click" key="authPopover">
												<div>
													<el-form ref="form" :model="form" label-width="80px">
														<el-form-item label="姓名">
															<el-input v-model="form.real_name"></el-input>
														</el-form-item>
														<el-form-item label="证件号">
															<el-input v-model="form.card_no"></el-input>
														</el-form-item>
														<el-form-item>
															<el-button type="primary" style="width: 100%"
																@click="authentication">认证</el-button>
														</el-form-item>
													</el-form>
												</div>

												<el-button slot="reference" v-if="userInfor.status == 0" type="warning"
													size="small" icon="el-icon-warning">
													您还未进行实名认证，点击前往认证 >>
												</el-button>
											</el-popover>
											<el-button slot="reference" v-if="userInfor.status == 1" type="success"											
											style="background: rgba(103, 194, 58, 0.15);border-color: #67C23A;color:#67C23A;"
												size="small" icon="el-icon-check" plain>
												已通过实名认证
											</el-button>
										</div>
									</div>
								</div>
								<div class="information">
									<el-row>
										<el-col :span="16">
											<div class="account">
												<div class="text-top">
													<span>账户概览</span>
													<span>
														<el-button size="small" class="detail-btn"
															@click="goExpend">消费明细</el-button>
													</span>
												</div>
												<div class="account-money">
													<div class="account-balancebox">
														<div class="account-balance">
															<div>
																<p>账户余额</p>
																<h3>{{ userInfor.money }}</h3>
																<span>元</span>
															</div>
															<div>
																<el-popover placement="right" width="400"
																	trigger="click" popper-class="recharge-popover">
																	<div class="recharge-dialog">
																		<div class="recharge-header">
																			<h3>账户充值</h3>
																			<p>当前余额: <span
																					class="balance">¥{{ userInfor.money || '0.00' }}</span>
																			</p>
																		</div>
																		<div class="recharge-amount">
																			<label>选择充值金额</label>
																			<div class="quick-amounts">
																				<div class="amount-item"
																					:class="{ active: money === item }"
																					v-for="item in [300, 50, 100, 200, 500, 1000]"
																					:key="item" @click="money = item">
																					¥{{ item }}
																				</div>
																			</div>
																		</div>
																		<div class="recharge-actions">
																			<el-button
																				@click="money = ''">取消</el-button>
																			<el-button type="primary"
																				@click="topUp">立即充值</el-button>
																		</div>
																	</div>
																	<el-button type="primary" size="mini"
																		slot="reference">充值</el-button>
																</el-popover>
															</div>
														</div>
														<div class="myintegral">
															<div>
																<p>我的积分</p>
																<h3>0</h3>
																<span><img src="../../assets/star.png" alt="" /></span>
															</div>
															<div>
																<el-button type="primary" size="mini">积分中心</el-button>
															</div>
														</div>
													</div>
													<div class="voucher">
														<div class="voucher-box">
															<div class="voucher-content">
																<p>可用代金券</p>
																<span><img src="../../assets/question.png"
																		alt="" /></span>
															</div>
															<div class="voucher-details">
																<span class="voucher-pice">{{ voucherCount }}</span>
																<span>张</span>
															</div>
														</div>
														<div class="voucher-box">
															<div class="voucher-content">
																<p>欠费金额</p>
																<span><img src="" alt="" /></span>
															</div>
															<div class="voucher-details">
																<span
																	class="voucher-pice voucher-red">{{ arrearsAmount }}</span>
																<span>元</span>
															</div>
														</div>
														<div class="voucher-box">
															<div class="voucher-content">
																<p>冻结金额</p>
																<span><img src="" alt="" /></span>
															</div>
															<div class="voucher-details">
																<span class="voucher-pice">{{ frozenAmount }}</span>
																<span>元</span>
															</div>
														</div>
														<div class="voucher-box">
															<div class="voucher-content">
																<p>可用额度预警</p>
																<span><img src="" alt="" /> </span>
															</div>
															<div class="voucher-details">
																<span
																	class="voucher-pice voucher-red">{{ warningAmount }}</span>
																<span>元</span>
															</div>
														</div>
														<div class="voucher-box">
															<div class="voucher-content">
																<p>待支付订单</p>
																<span><img src="" alt="" /></span>
															</div>
															<div class="voucher-details">
																<span
																	class="voucher-pice">{{ pendingOrderCount }}</span>
																<span>个</span>
															</div>
														</div>
													</div>
												</div>
											</div>
										</el-col>
										<el-col :span="8">
											<div class="feature">
												<div class="text-top">最新公告</div>
												<div class="server-content">
													<ul>
														<li>
															<p>喜报！快快网络林思弘先生荣获“福建青年五四奖章”</p>
															<span>2025-11-17</span>
														</li>
														<li>
															<p>喜报！快快网络林思弘先生荣获“福建青年五四奖章”</p>
															<span>2025-11-17</span>
														</li>
														<li>
															<p>喜报！快快网络林思弘先生荣获“福建青年五四奖章”</p>
															<span>2025-11-17</span>
														</li>
													</ul>
												</div>
											</div>
										</el-col>
									</el-row>
								</div>
								<div class="serve">
									<el-row>
										<el-col :span="24">
											<div class="server">
												<div class="server-top">产品及服务</div>
												<div class="application">
													<div class="application-item" v-for="item in ProductList"
														:key="item.id">
														<img :src="item.image" alt="" />
														<div>
															<div class="application-content">
																<span>应用</span> {{ item.title }}
																<div class="application-foot">
																	<el-button type="primary" size="mini"
																		@click="open">开通应用</el-button>
																	<div>
																		<strong>¥</strong>
																		{{ item.billing_price }}/
																		<template>
																			{{
																		    item.billing_type === 1 ? "次" : 
																		    item.billing_type === 2 ? "秒" : 
																		    item.billing_type === 3 ? "张" : 
																		    item.billing_type === 4 ? "tokens" : 
																		    "其他" 
																		  }}
																		</template>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</el-col>
									</el-row>
								</div>
							</div>
							<router-view></router-view>
						</main>
					</div>
				</el-main>
			</el-container>
		</el-container>


	</div>
</template>

<script>
	export default {
		data() {
			return {
				userInfor: {},
				form: {},
				money: "",
				ProductList: {},
				voucherCount: 0,
				arrearsAmount: '0.00',
				frozenAmount: '0.00',
				warningAmount: '0.00',
				pendingOrderCount: 0,
				showContactDialog: false,
			};
		},
		methods: {
			goDashboard() {
				if (this.$route.path !== "/index/dashboard") {
					this.$router.push({
						path: "/index/dashboard",
					});
				}
			},
			goQiniu() {
				if (this.$route.path !== "/index/qiniu") {
					this.$router.push({
						path: "/index/qiniu",
					});
				}
			},
			goindex() {
				this.$router.push({
					path: "/",
				});
			},
			async getUser() {
				const res = await this.$api.getUserInfo.get();
				console.log(res);
				if (res.code == 200) {
					this.userInfor = res.data;
					this.updateAccountData();
				} else {
					this.$message(res.msg)
					this.$router.push({
						path: "/login",
					});
				}
			},
			updateAccountData() {
				if (this.userInfor) {
					this.voucherCount = this.userInfor.voucher_count || 0;
					this.arrearsAmount = this.userInfor.arrears || '0.00';
					this.frozenAmount = this.userInfor.frozen_money || '0.00';
					this.warningAmount = this.userInfor.warning_amount || '0.00';
				}
			},
			async getPendingOrders() {
				try {
					const res = await this.$api.order.getOrderList({
						status: 0
					});
					if (res.code === 200 && res.data) {
						const list = res.data.list || res.data || [];
						this.pendingOrderCount = list.length || 0;
					}
				} catch (e) {
					console.error('获取待支付订单失败:', e);
				}
			},
			async loginout() {
				const res = await this.$api.login.out();
				console.log(res);
				if (res.code == 200) {
					this.$message("退出成功");
					localStorage.removeItem('userInfo');
					this.$router.push({
						path: "/",
					});
				} else {
					this.$router.push({
						path: "/login",
					});
				}
			},
			async authentication() {
				const res = await this.$api.login.auth(this.form);
				if (res.code == 200) {
					this.$message.success(res.msg);
					localStorage.setItem('userInfo.auth_name', this.form.real_name)
					localStorage.setItem('userInfo.card_num', this.form.card_no)
					localStorage.setItem('userInfo.status', 1)
				} else {
					this.$message.error("实名失败：" + res.msg);
					return
				}
			},
			ChangeInfo() {
				//修改信息

				if (this.$route.path !== "/index/ChangeInfo") {
					this.$router.push({
						path: "/index/ChangeInfo",
					});
				}
			},
			goOrder() {
				//订单
				if (this.$route.path !== "/index/order") {
					this.$router.push({
						path: "/index/order",
					});
				}
			},
			goregulate() {
				//应用管理
				if (this.$route.path !== "/index/apps") {
					this.$router.push({
						path: "/index/apps",
					});
				}
			},
			openApiDoc() {
				window.open('https://s.apifox.cn/99d32eb0-7b13-4b37-a95e-42d925207c46?pwd=123456', '_blank')
			},
			goAgent() {
				if (this.$route.path !== '/index/agent') {
					this.$router.push('/index/agent')
				}
			},
			goapply() {
				this.$router.push({
					path: "/market",
				});
			},
			async topUp() {
				//充值订单
				if (!this.money) {
					this.$message.warning("请输入金额");
					return;
				} else {
					const res = await this.$api.order.gotopUpt({
						money: this.money
					});
					// 先提前打开空白窗口（避免被拦截）
					const payWindow = window.open('', `pay_${Date.now()}`, 'width=800,height=600');
					if (!payWindow) {
						this.$message.warning("浏览器拦截了支付窗口，请允许弹窗后重试");
						return;
					}
					try {
						const res = await this.$api.order.gotopUpt({
							money: this.money
						});
						console.log(123, res);
						// 写入内容到新窗口
						payWindow.document.write(res);
						payWindow.document.close();
					} catch (e) {
						// 接口失败时关闭空白窗口
						payWindow.close();
						this.$message.error("充值请求失败：" + e.message);
					}
				}
			},
			all() {
				//总览

				if (this.$route.path !== "/index") {
					this.$router.push({
						path: "/index",
					});
				}
			},
			async getProductList() {
				//应用列表
				const res = await this.$api.market.getProductList();
				if (res.code == 200) {
					// console.log("应用列表", res);

					this.ProductList = res.data;
				}
			},
			open() { //开通应用
				this.$router.push({
					path: "/index/apps",
				});
			},
			goExpend() {
				if (this.$route.path !== "/index/Expend") {
					this.$router.push({
						path: "/index/Expend",
					});
				}
			}
		},
		created() {
			this.getUser();
			this.getProductList();
			this.getPendingOrders();
		},
	};
</script>

<style lang="scss" scoped>
	nav {
		width: calc(100% - 240px);
		height: 64px;
		padding: 0 30px;
		background: linear-gradient(135deg, #ffffff 0%, #f8f9fc 100%);
		color: #424641;
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
		position: fixed;
		top: 0;
		left: 240px;
		z-index: 9;

		.left {
			height: 100%;
			display: flex;
			align-items: center;

			span {
				font-size: 14px;
				font-weight: 600;
				color: #fff;
				margin-left: 16px;
				position: relative;
				padding: 10px 24px;
				border-radius: 12px;
				transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
				cursor: pointer;
				background: linear-gradient(145deg, #5e60ce, #7c7ff6);
				box-shadow:
					0 4px 15px rgba(94, 96, 206, 0.35),
					0 2px 4px rgba(94, 96, 206, 0.2),
					inset 0 1px 0 rgba(255, 255, 255, 0.2),
					inset 0 -2px 0 rgba(0, 0, 0, 0.1);
				transform-style: preserve-3d;
				transform: perspective(500px) rotateX(0deg);

				&::before {
					content: '';
					position: absolute;
					inset: 0;
					border-radius: 12px;
					background: linear-gradient(135deg, rgba(255, 255, 255, 0.25), transparent 50%);
					pointer-events: none;
				}

				&:hover {
					transform: perspective(500px) rotateX(5deg) translateY(-3px);
					box-shadow:
						0 8px 25px rgba(94, 96, 206, 0.45),
						0 4px 8px rgba(94, 96, 206, 0.25),
						inset 0 1px 0 rgba(255, 255, 255, 0.3),
						inset 0 -2px 0 rgba(0, 0, 0, 0.1);
				}

				&:active {
					transform: perspective(500px) rotateX(-2deg) translateY(0);
					box-shadow:
						0 2px 8px rgba(94, 96, 206, 0.3),
						inset 0 1px 0 rgba(255, 255, 255, 0.1),
						inset 0 2px 4px rgba(0, 0, 0, 0.15);
				}
			}
		}

		.right {
			display: flex;
			align-items: center;

			ul {
				display: flex;
				gap: 12px;
			}

			li {
				list-style: none;
				font-size: 14px;
				display: flex;
				align-items: center;
				padding: 10px 20px;
				border-radius: 12px;
				cursor: pointer;
				transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
				position: relative;
				color: #fff;
				font-weight: 500;
				background: linear-gradient(145deg, #5e60ce, #7c7ff6);
				box-shadow:
					0 4px 15px rgba(94, 96, 206, 0.35),
					0 2px 4px rgba(94, 96, 206, 0.2),
					inset 0 1px 0 rgba(255, 255, 255, 0.2),
					inset 0 -2px 0 rgba(0, 0, 0, 0.1);
				transform-style: preserve-3d;
				transform: perspective(500px) rotateX(0deg);

				&::before {
					content: '';
					position: absolute;
					inset: 0;
					border-radius: 12px;
					background: linear-gradient(135deg, rgba(255, 255, 255, 0.25), transparent 50%);
					pointer-events: none;
				}

				&:hover {
					transform: perspective(500px) rotateX(5deg) translateY(-3px);
					box-shadow:
						0 8px 25px rgba(94, 96, 206, 0.45),
						0 4px 8px rgba(94, 96, 206, 0.25),
						inset 0 1px 0 rgba(255, 255, 255, 0.3),
						inset 0 -2px 0 rgba(0, 0, 0, 0.1);
				}

				&:active {
					transform: perspective(500px) rotateX(-2deg) translateY(0);
					box-shadow:
						0 2px 8px rgba(94, 96, 206, 0.3),
						inset 0 1px 0 rgba(255, 255, 255, 0.1),
						inset 0 2px 4px rgba(0, 0, 0, 0.15);
				}

				img {
					height: 20px;
					margin-right: 8px;
				}
			}
		}
	}

	aside {
		background: linear-gradient(180deg, #ffffff 0%, #f8f9fc 100%);
		padding: 0;
		transition: all 0.3s ease;
		box-sizing: border-box;
		overflow: hidden;
		height: 100vh;
		min-height: calc(100vh - 50px);
		flex-shrink: 0;
		position: relative;
		box-shadow:
			4px 0 20px rgba(94, 96, 206, 0.08),
			inset -1px 0 0 rgba(94, 96, 206, 0.05);
		display: flex;
		flex-direction: column;

		&::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			height: 200px;
			background: linear-gradient(180deg, rgba(94, 96, 206, 0.03) 0%, transparent 100%);
			pointer-events: none;
		}

		.left-logo {
			width: 100%;
			height: 70px;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 15px 20px;
			margin-bottom: 10px;
			border-bottom: 1px solid rgba(94, 96, 206, 0.08);
			position: relative;

			&::after {
				content: '';
				position: absolute;
				bottom: -1px;
				left: 20px;
				right: 20px;
				height: 1px;
				background: linear-gradient(90deg, transparent, rgba(94, 96, 206, 0.15), transparent);
			}

			img {
				width: 120px;
				height: auto;
				filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
			}
		}

		.nav-menu {
			flex: 1;
			padding: 16px 12px;
			overflow-y: auto;

			&::-webkit-scrollbar {
				width: 4px;
			}

			&::-webkit-scrollbar-thumb {
				background: rgba(94, 96, 206, 0.2);
				border-radius: 2px;
			}
		}

		.nav-item {
			height: 56px;
			width: 100%;
			padding: 0 18px;
			margin-bottom: 8px;
			color: #4a4a68;
			display: flex;
			align-items: center;
			font-size: 15px;
			font-weight: 500;
			cursor: pointer;
			border-radius: 14px;
			transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
			position: relative;
			background: transparent;
			box-shadow: none;
			transform: translateZ(0);
			letter-spacing: 0.3px;

			.nav-icon {
				width: 40px;
				height: 40px;
				border-radius: 12px;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-right: 14px;
				background: rgba(94, 96, 206, 0.05);
				transition: all 0.35s ease;

				img {
					width: 24px;
					height: 24px;
					object-fit: contain;
					transition: transform 0.35s ease;
				}
			}

			.nav-text {
				flex: 1;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				transition: color 0.35s ease;
			}

			.nav-indicator {
				position: absolute;
				right: 14px;
				width: 8px;
				height: 8px;
				border-radius: 50%;
				background: transparent;
				transition: all 0.35s ease;
			}

			&:hover {
				background: linear-gradient(135deg, rgba(94, 96, 206, 0.1), rgba(124, 127, 246, 0.08));
				transform: translateX(6px);
				box-shadow:
					0 6px 20px rgba(94, 96, 206, 0.12),
					0 2px 8px rgba(94, 96, 206, 0.08),
					inset 0 1px 0 rgba(255, 255, 255, 0.8);

				.nav-icon {
					background: linear-gradient(135deg, rgba(94, 96, 206, 0.15), rgba(124, 127, 246, 0.1));
					transform: scale(1.05);

					img {
						transform: scale(1.15) rotate(5deg);
					}
				}

				.nav-text {
					color: #5e60ce;
					font-weight: 600;
				}
			}

			&.active {
				background: linear-gradient(135deg, #5e60ce 0%, #7c7ff6 50%, #8b8fff 100%);
				color: #ffffff;
				box-shadow:
					0 10px 30px rgba(94, 96, 206, 0.4),
					0 6px 15px rgba(94, 96, 206, 0.25),
					0 2px 6px rgba(94, 96, 206, 0.15),
					inset 0 1px 0 rgba(255, 255, 255, 0.25);
				transform: translateX(6px) scale(1.03);

				.nav-icon {
					background: rgba(255, 255, 255, 0.25);
					box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

					img {
						filter: brightness(0) invert(1);
						transform: scale(1.1);
					}
				}

				.nav-text {
					color: #ffffff;
					font-weight: 700;
					text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
				}

				.nav-indicator {
					background: rgba(255, 255, 255, 0.9);
					box-shadow: 0 0 12px rgba(255, 255, 255, 0.6);
					animation: pulse 2s ease-in-out infinite;
				}
			}
		}

		@keyframes pulse {

			0%,
			100% {
				transform: scale(1);
				opacity: 1;
			}

			50% {
				transform: scale(1.3);
				opacity: 0.7;
			}
		}

		.contact-card {
			margin: 12px;
			padding: 20px;
			background: linear-gradient(145deg, #ffffff, #f8f9fc);
			border-radius: 16px;
			border: 1px solid rgba(94, 96, 206, 0.12);
			position: relative;
			overflow: hidden;
			transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
			box-shadow:
				0 4px 16px rgba(94, 96, 206, 0.08),
				0 1px 3px rgba(94, 96, 206, 0.05),
				inset 0 1px 0 rgba(255, 255, 255, 0.8);
			transform-style: preserve-3d;

			&::before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				height: 3px;
				background: linear-gradient(90deg, #5e60ce, #7c7ff6, #2ec4b6);
				opacity: 0;
				transition: opacity 0.3s ease;
			}

			&:hover {
				transform: perspective(1000px) rotateX(2deg) translateY(-4px);
				box-shadow:
					0 12px 32px rgba(94, 96, 206, 0.15),
					0 4px 8px rgba(94, 96, 206, 0.08),
					inset 0 1px 0 rgba(255, 255, 255, 0.9);
				border-color: rgba(94, 96, 206, 0.2);

				&::before {
					opacity: 1;
				}
			}

			.contact-icon {
				width: 52px;
				height: 52px;
				border-radius: 50%;
				background: transparent;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-bottom: 16px;
				position: relative;
				z-index: 1;

				img {
					width: 40px;
					height: 40px;
					object-fit: contain;
				}
			}

			.contact-content {
				position: relative;
				z-index: 1;
				margin-bottom: 16px;

				.contact-title {
					font-size: 16px;
					font-weight: 700;
					color: #1a1a2e;
					margin-bottom: 6px;
				}

				.contact-desc {
					font-size: 13px;
					color: #8a8aa3;
				}
			}

			.contact-btn {
				width: 100%;
				padding: 12px 18px;
				border-radius: 12px;
				border: none;
				background: linear-gradient(145deg, #ff6b35, #ff8c42);
				color: white;
				font-size: 14px;
				font-weight: 600;
				cursor: pointer;
				transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
				position: relative;
				z-index: 1;
				box-shadow:
					0 4px 12px rgba(255, 107, 53, 0.35),
					0 2px 4px rgba(255, 107, 53, 0.2),
					inset 0 1px 0 rgba(255, 255, 255, 0.25),
					inset 0 -2px 0 rgba(0, 0, 0, 0.1);
				transform-style: preserve-3d;

				&:hover {
					transform: perspective(500px) rotateX(3deg) translateY(-2px);
					box-shadow:
						0 8px 20px rgba(255, 107, 53, 0.45),
						0 4px 8px rgba(255, 107, 53, 0.25),
						inset 0 1px 0 rgba(255, 255, 255, 0.35),
						inset 0 -2px 0 rgba(0, 0, 0, 0.1);
				}

				&:active {
					transform: perspective(500px) rotateX(-1deg) translateY(0);
					box-shadow:
						0 2px 6px rgba(255, 107, 53, 0.35),
						inset 0 1px 0 rgba(255, 255, 255, 0.15),
						inset 0 2px 4px rgba(0, 0, 0, 0.15);
				}
			}
		}
	}

	.content {
		width: 100%;
		background-color: #F1F3FB;
		display: flex;
		min-height: calc(100vh - 50px);

		main {
			box-sizing: border-box;
			width: 100%;
			flex: 1;
			display: flex;
			flex-direction: column;
			height: calc(100vh - 50px);

			.head {
				width: 99%;
				min-height: 130px;
				padding: 24px 32px;
				background: linear-gradient(135deg, #ffffff 0%, #f8f9fc 100%);
				border-radius: 16px;
				display: flex;
				align-items: center;
				overflow: hidden;
				box-sizing: border-box;
				margin: 10px 0 0 10px;
				box-shadow:
					0 4px 20px rgba(94, 96, 206, 0.08),
					0 0 0 1px rgba(94, 96, 206, 0.05);
				position: relative;

				&::before {
					content: '';
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					height: 3px;
					background: linear-gradient(90deg, #5e60ce, #2ec4b6, #ff6b35);
					background-size: 200% 100%;
					animation: headerGradient 3s ease infinite;
				}

				@keyframes headerGradient {

					0%,
					100% {
						background-position: 0% 50%;
					}

					50% {
						background-position: 100% 50%;
					}
				}

				&>div:first-child {
					position: relative;

					&::before {
						content: '';
						position: absolute;
						inset: -4px;
						border-radius: 50%;
						background: linear-gradient(135deg, #5e60ce, #7c7ff6);
						opacity: 0.2;
						animation: avatarPulse 2s ease-in-out infinite;
					}

					@keyframes avatarPulse {

						0%,
						100% {
							transform: scale(1);
							opacity: 0.2;
						}

						50% {
							transform: scale(1.1);
							opacity: 0.3;
						}
					}
				}

				img {
					width: 80px;
					height: 80px;
					border-radius: 50%;
					object-fit: cover;
					border: 3px solid #fff;
					box-shadow: 0 4px 16px rgba(94, 96, 206, 0.2);
					position: relative;
					z-index: 1;
				}

				.infor {
					margin-left: 24px;
					flex: 1;

					h6 {
						font-size: 22px;
						color: #1a1a2e;
						font-weight: 700;
						margin: 0 0 8px 0;
						background: linear-gradient(135deg, #1a1a2e, #4a4a68);
						-webkit-background-clip: text;
						-webkit-text-fill-color: transparent;
						background-clip: text;
					}

					p {
						font-size: 14px;
						color: #8a8aa3;
						line-height: 1.6;
						margin: 0 0 12px 0;

						&::before {
							content: '';
							display: inline-block;
							width: 6px;
							height: 6px;
							border-radius: 50%;
							background: linear-gradient(135deg, #5e60ce, #7c7ff6);
							margin-right: 8px;
							vertical-align: middle;
						}
					}

					.el-button {
						font-size: 13px;
						color: #ff6b53;
						cursor: pointer;
						border: none;
						padding: 8px 16px;
						background: rgba(255, 107, 83, 0.08);
						border-radius: 20px;
						transition: all 0.3s ease;

						&:hover {
							background: rgba(255, 107, 83, 0.15);
							transform: translateX(4px);
						}
					}

					a {
						margin-left: 6px;
						display: inline-block;
						width: 22px;
						height: 22px;
						line-height: 22px;
						text-align: center;
						background-color: #97a1b9;
						color: #fff;
						border-radius: 22px;
						vertical-align: text-bottom;
						position: relative;
						text-decoration: none;
					}
				}
			}

			.information {
				margin-top: 20px;
				margin-left: 10px;

				.account,
				.feature {
					color: #000;
					height: 240px;
					background-color: #fff;
					margin-right: 10px;

					.text-top {
						font-size: 14px;
						padding: 0 25px;
						line-height: 50px;
						border-bottom: 1px solid #edf0f7;
						font-weight: bold;
						display: flex;
						justify-content: space-between;
						align-items: center;

						.detail-btn {
							padding: 8px 20px;
							border-radius: 10px;
							border: none;
							background: linear-gradient(145deg, #ffffff, #f0f0f5);
							color: #5e60ce;
							font-size: 13px;
							font-weight: 600;
							cursor: pointer;
							transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
							box-shadow:
								0 2px 8px rgba(94, 96, 206, 0.1),
								0 1px 2px rgba(94, 96, 206, 0.05),
								inset 0 1px 0 rgba(255, 255, 255, 0.8),
								inset 0 -1px 0 rgba(0, 0, 0, 0.05);
							transform-style: preserve-3d;

							&:hover {
								transform: perspective(500px) rotateX(3deg) translateY(-2px);
								box-shadow:
									0 6px 16px rgba(94, 96, 206, 0.15),
									0 2px 4px rgba(94, 96, 206, 0.1),
									inset 0 1px 0 rgba(255, 255, 255, 0.9);
								color: #7c7ff6;
							}

							&:active {
								transform: perspective(500px) rotateX(-1deg) translateY(0);
								box-shadow:
									0 1px 3px rgba(94, 96, 206, 0.1),
									inset 0 1px 0 rgba(255, 255, 255, 0.5),
									inset 0 1px 2px rgba(0, 0, 0, 0.1);
							}
						}
					}

					.feature-content {
						display: flex;
						align-items: center;
						justify-content: center;
						height: calc(100% - 50px);

						.feature-box {
							width: 50%;
							height: 100%;
							border-right: 1px solid #edf0f7;
							padding: 20px;
							box-sizing: border-box;
							display: flex;
							flex-direction: column;

							.el-button {
								align-self: flex-end;
							}

							.feature-box-top {
								display: flex;
								align-items: center;

								span {
									font-size: 14px;
									font-weight: bold;
									color: #333;
								}
							}

							p {
								font-size: 12px;
								line-height: 18px;
								color: #4c4c4c;
								margin: 12px 0 2px;
								min-height: 54px;
							}
						}
					}

					.account-money {
						display: flex;
						padding: 20px 25px;

						.el-button {
							width: 75px;
							height: 30px;
						}

						.account-balancebox {
							width: 35%;

							.account-balance {
								height: 55px;
								padding-bottom: 19px;
								border-bottom: 1px dashed #e5e8ef;
								border-right: 1px dashed #e5e8ef;
								display: flex;
								justify-content: space-between;
								align-items: center;
								padding-right: 25px;

								p {
									font-size: 12px;
									color: #4e5771;
									margin-bottom: 15px;
								}

								h3 {
									font-weight: normal;
									display: inline-block;
									margin-right: 5px;
									height: 25px;
								}

								span {
									display: inline-block;
									font-size: 12px;
								}
							}

							.myintegral {
								height: 55px;
								padding-top: 19px;
								padding-right: 25px;
								display: flex;
								justify-content: space-between;
								align-items: center;

								p {
									font-size: 12px;
									color: #4e5771;
									margin-bottom: 15px;
								}

								h3 {
									display: inline-block;
									font-weight: normal;
									font-size: 20px;
									line-height: 20px;
									margin-right: 5px;
								}
							}
						}

						.voucher {
							width: 65%;
							padding-left: 25px;
							display: flex;
							flex-wrap: wrap; // 允许换行
							gap: 20px 0;

							.voucher-box {
								width: calc((100% / 3) - 10px);
								height: 55px;
							}

							.voucher-content {
								display: flex;
								align-items: center;
								gap: 6px;
								line-height: 1;
								margin-bottom: 15px;

								p {
									display: inline-block;
									font-size: 12px;
									color: #4e5771;
								}

								span {
									display: inline-block;
									vertical-align: middle;
								}

								img {
									width: 16px;
									height: 16px;
									vertical-align: center;
								}
							}

							.voucher-details {
								span {
									display: inline-block;
									font-size: 16px;
									margin-right: 15px;
									line-height: 1;
								}

								.voucher-pice {
									color: #0078ff;
								}

								.voucher-red {
									color: #f6667f;
								}
							}
						}
					}
				}
			}

			.server,
			.product {
				color: #000;
				min-height: 450px;
				background-color: #fff;
				margin-top: 20px;
				padding: 20px;
				margin-right: 10px;
				margin-left: 10px;
				border-radius: 16px;
				box-shadow:
					0 4px 20px rgba(94, 96, 206, 0.08),
					0 0 0 1px rgba(94, 96, 206, 0.05);

				.application {
					display: grid;
					grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
					justify-content: space-between;
					margin: 0 auto;
					padding: 20px;
					gap: 20px 16px;

					.application-item {
						background-color: #ffffff;
						padding: 0;
						box-sizing: border-box;
						margin-bottom: 0;
						box-shadow:
							0 2px 12px rgba(94, 96, 206, 0.06),
							0 0 0 1px rgba(94, 96, 206, 0.04);
						display: flex;
						flex-direction: column;
						align-items: center;
						border-radius: 16px;
						overflow: hidden;
						transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

						&:hover {
							transform: translateY(-8px);
							box-shadow:
								0 12px 32px rgba(94, 96, 206, 0.15),
								0 4px 12px rgba(94, 96, 206, 0.1);
						}

						img {
							width: 100%;
							height: 160px;
							object-fit: cover;
						}

						.application-content {
							width: 100%;
							min-height: 90px;
							padding: 16px;
							font-size: 12px;
							font-weight: 600;
							text-align: left;
							display: flex;
							flex-direction: column;
							gap: 10px;

							span {
								display: inline-block;
								width: 50px;
								height: 24px;
								line-height: 24px;
								padding: 0 10px;
								background: linear-gradient(135deg, #ff6b53, #ff8c6b);
								font-size: 11px;
								font-weight: 600;
								color: #ffffff;
								border-radius: 6px;
								box-shadow: 0 2px 8px rgba(255, 107, 83, 0.3);
							}

							.application-foot {
								display: flex;
								justify-content: space-between;
								align-items: center;
								font-size: 13px;
								padding-top: 8px;

								.el-button {
									height: 30px;
									line-height: 30px;
									padding: 0 14px;
									background: linear-gradient(135deg, #5e60ce, #7c7ff6);
									border: none;
									box-shadow: 0 4px 12px rgba(94, 96, 206, 0.3);

									&:hover {
										transform: translateY(-2px);
										box-shadow: 0 6px 16px rgba(94, 96, 206, 0.4);
									}
								}

								div {
									height: auto;
									margin-top: 0;
									line-height: 1;
									color: #ff6b53;
									font-weight: 700;

									strong {
										font-size: 14px;
									}
								}
							}
						}
					}
				}

				.server-top,
				.product-top {
					font-size: 16px;
					padding: 0 20px;
					line-height: 50px;
					border-bottom: 1px solid #edf0f7;
					font-weight: 700;
					display: flex;
					justify-content: space-between;
					color: #1a1a2e;
				}
			}

			.recommend-box {
				display: grid;
				grid-template-columns: repeat(3, 1fr);
				gap: 20px 30px;
				padding: 20px 25px;

				.recommend {
					padding: 20px 25px;
					display: flex;

					img {
						width: 28px;
						height: 28px;
					}

					.recommend-text {
						margin-left: 16px;
						width: 231px;

						strong {
							font-size: 14px;
							margin: 5px 0 9px;
							color: #222222;
							line-height: 1;
							margin: 5px 0 9px 0;
						}

						p {
							font-size: 12px;
							color: #444444;
							line-height: 16px;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
							overflow: hidden;
							text-overflow: ellipsis;
						}

						.recommend-btn {
							margin-top: 15px;

							a {
								margin-left: 25px;
								color: #275ffd;
								font-size: 12px;
							}
						}
					}
				}
			}

			.server-content {
				padding: 0 25px;

				ul {
					list-style: none; // 移除默认样式
					padding: 0;

					li {
						height: 50px;
						display: flex;
						align-items: center;
						justify-content: space-between;
						line-height: 50px;
						color: #646b7f;
						font-size: 12px;
						position: relative;
						padding-left: 20px; // 为自定义圆点留空间
						border-bottom: 1px dashed #e5e8ef;

						&::before {
							content: "•";
							color: #dededf;
							font-size: 20px;
							position: absolute;
							left: 0;
							line-height: 50px;
						}

						p {
							margin: 0;
							flex: 1;
							margin-right: 10px;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}

						span {
							flex-shrink: 0;
						}
					}
				}
			}
		}
	}

	.contact-dialog {
		border-radius: 16px;

		.el-dialog__header {
			padding: 20px 20px 15px;
			border-bottom: 1px solid #f0f0f0;

			.el-dialog__title {
				font-size: 18px;
				font-weight: 600;
				color: #1a1a2e;
			}
		}

		.el-dialog__body {
			padding: 30px 40px;
		}
	}

	.contact-qrcode {
		display: flex;
		justify-content: center;
		margin-bottom: 20px;

		img {
			width: 260px;
			height: 260px;
			border-radius: 12px;
			box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
		}
	}

	.contact-tip {
		text-align: center;
		font-size: 14px;
		color: #8a8aa3;
		margin: 0;
	}

	.recharge-dialog {
		padding: 10px;

		.recharge-header {
			margin-bottom: 24px;

			h3 {
				font-size: 18px;
				font-weight: 600;
				color: #1a1a2e;
				margin: 0 0 12px 0;
			}

			p {
				font-size: 14px;
				color: #8a8aa3;
				margin: 0;

				.balance {
					font-size: 20px;
					font-weight: 700;
					color: #5e60ce;
				}
			}
		}

		.recharge-amount {
			label {
				display: block;
				font-size: 14px;
				color: #4a4a68;
				margin-bottom: 12px;
				font-weight: 500;
			}

			.quick-amounts {
				display: grid;
				grid-template-columns: repeat(3, 1fr);
				gap: 12px;
				margin-bottom: 16px;

				.amount-item {
					padding: 14px 12px;
					text-align: center;
					border: 2px solid #e8eaf2;
					border-radius: 12px;
					font-size: 16px;
					font-weight: 600;
					color: #4a4a68;
					cursor: pointer;
					transition: all 0.3s ease;
					background: #ffffff;

					&:hover {
						border-color: #5e60ce;
						color: #5e60ce;
						background: rgba(94, 96, 206, 0.03);
					}

					&.active {
						border-color: #5e60ce;
						background: linear-gradient(135deg, rgba(94, 96, 206, 0.1), rgba(124, 127, 246, 0.05));
						color: #5e60ce;
						box-shadow: 0 4px 12px rgba(94, 96, 206, 0.15);
					}
				}
			}
		}

		.recharge-actions {
			display: flex;
			justify-content: flex-end;
			gap: 12px;
			margin-top: 24px;
			padding-top: 20px;
			border-top: 1px solid #f0f0f0;

			.el-button {
				padding: 12px 24px;
				border-radius: 10px;
				font-weight: 500;

				&:first-child {
					background: #f5f5f7;
					border: none;
					color: #6a6a8a;

					&:hover {
						background: #e8e8ea;
					}
				}

				&:last-child {
					background: linear-gradient(135deg, #5e60ce, #7c7ff6);
					border: none;
					box-shadow: 0 4px 12px rgba(94, 96, 206, 0.3);

					&:hover {
						transform: translateY(-2px);
						box-shadow: 0 6px 16px rgba(94, 96, 206, 0.4);
					}
				}
			}
		}
	}
</style>